import SettingsPage from './SettingsPage.vue';
import { SHELL_PATHS } from './appMenuStore.js';

/**
 * The pages behind the shell's own paths: Profile and Settings.
 *
 * Profile is the identity package's page, and a target hands it in — each
 * target imports it from its own side of that package. Sign-in & security is
 * not here: it is on the identity package's path, and an app already has it
 * through the identity routes it spreads.
 *
 * Spread the result into an app's vue-router `routes`. It is the one line an
 * app adds for the shell, and it has to be there before the app starts: a page
 * with an address must be known when a person opens that address directly.
 */
function createShellRoutes({ ProfilePage }) {
    return [
        { path: SHELL_PATHS.profile, component: ProfilePage },
        { path: SHELL_PATHS.settings, component: SettingsPage }
    ];
}

export { createShellRoutes };
